import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import LOGO from '../../assets/LOGO.png';

const Footer = () => {
    return (
        <Box
            sx={{
                py: 6,
                backgroundColor:
                    'linear-gradient(135deg, #6da7d0 0%, #6da7d0 100%, #5637ee 78%)',
                color: 'white',
            }}
        >
            <Container maxWidth="lg">
                <Grid
                    container
                    spacing={12}
                    justifyContent={'space-between'}
                >
                    <Grid item xs={12} md={3}>
                        <Link to="/">
                            <img
                                src={LOGO}
                                alt="Happenings Logo"
                                className="logo"
                            />
                        </Link>
                        <Typography
                            variant="body2"
                            sx={{ opacity: 0.7, paddingTop: '25px' }}
                        >
                            AI-powered event planning platform for modern
                            businesses.
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <Typography 
                            variant="h6" 
                            sx={{ 
                                mb: 2,
                                fontWeight: 700,
                                fontSize: '1.25rem'
                            }}
                        >
                            Product
                        </Typography>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 1,
                            }}
                        >
                            <Link
                                onClick={(e) => {
                                    e.preventDefault()
                                    document
                                        .getElementById('features-section')
                                        .scrollIntoView({
                                            behavior: 'smooth',
                                        })
                                }}
                                className="footer-link"
                                style={{ 
                                    cursor: 'pointer',
                                    opacity: 0.7,
                                    transition: 'opacity 0.2s ease',
                                    textDecoration: 'none',
                                    color: 'white'
                                }}
                                sx={{
                                    '&:hover': {
                                        opacity: 1
                                    }
                                }}
                            >
                                Solutions
                            </Link>
                            <Link
                                onClick={(e) => {
                                    e.preventDefault()
                                    document
                                        .getElementById('pricing-section')
                                        .scrollIntoView({
                                            behavior: 'smooth',
                                        })
                                }}
                                className="footer-link"
                                style={{ 
                                    cursor: 'pointer',
                                    opacity: 0.7,
                                    transition: 'opacity 0.2s ease',
                                    textDecoration: 'none',
                                    color: 'white'
                                }}
                                sx={{
                                    '&:hover': {
                                        opacity: 1
                                    }
                                }}
                            >
                                Early Access
                            </Link>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <Typography 
                            variant="h6" 
                            sx={{ 
                                mb: 2,
                                fontWeight: 700,
                                fontSize: '1.25rem'
                            }}
                        >
                            Connect
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Link
                                href="mailto:team@happenings.dev"
                                className="footer-link"
                                style={{ 
                                    cursor: 'pointer',
                                    opacity: 0.7,
                                    transition: 'opacity 0.2s ease',
                                    textDecoration: 'none',
                                    color: 'white'
                                }}
                                sx={{
                                    '&:hover': {
                                        opacity: 1
                                    }
                                }}
                            >
                                team@happenings.dev
                            </Link>
                            
                            <a
                                href="https://cal.com/happenings"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="footer-link"
                                style={{ 
                                    cursor: 'pointer',
                                    opacity: 0.7,
                                    transition: 'opacity 0.2s ease',
                                    textDecoration: 'none',
                                    color: 'white'
                                }}
                            >
                                Schedule a Demo
                            </a>
                        </Box>
                    </Grid>
                </Grid>
                <Box
                    sx={{
                        mt: 4,
                        borderTop: '2px solid white',
                        opacity: 0.2, // Adjust opacity for subtle effect
                    }}
                />
                <Typography
                    variant="body2"
                    sx={{
                        mt: 4,
                        pt: 2,
                        borderTop: '1px solid rgba(255,255,255,0.1)',
                        opacity: 0.7,
                        textAlign: 'center',
                    }}
                >
                    © 2025 Happenings. All rights reserved.
                </Typography>
            </Container>
        </Box>
    );
};

export default Footer; 